module.exports = __webpack_public_path__ + "/login_ui/img/nz-f113106d1df16fed036495f34e8d86fe.svg";